import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {SystemModule} from "../system/system.module";
import {FrameworkModule} from "../framework/framework.module";
import {ContactSharedModule} from "../contact/contact.shared.module";
import {MembershipTypeSingleSelectEditControlComponent} from "./membership-type/controls/membership-type-single-select-edit-control.component";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {MemberLoyaltyRedemptionTypeSingleSelectEditControlComponent} from "./points/controls/member-loyalty-redemption-type-single-select-edit-control.component";
import {MemberLoyaltyRedemptionTypeSingleSelectColumnComponent} from "./points/controls/member-loyalty-redemption-type-single-select-column.component";
import {MembershipTypeReportSelectionControlComponent} from "./membership-type/controls/membership-type-report-selection-control.component";
import {MemberNoSingleSelectEditControlComponent} from "./member/controls/member-no-single-select-edit-control.component";
import {MemberReportSelectionControlComponent} from "./member/controls/member-report-selection-control.component";
import {MembershipTypeMultiSelectEditControlComponent} from "./membership-type/controls/membership-type-multi-select-edit-control.component";
import {MemberLoyaltyAccrualTypeSingleSelectEditControlComponent} from "./points/controls/member-loyalty-accrual-type-single-select-edit-control.component";
import {MemberLoyaltyAccrualTypeSingleSelectColumnComponent} from "./points/controls/member-loyalty-accrual-type-single-select-column.component";
import {
    MembershipTypeMultiSelectColumnComponent
} from "./membership-type/controls/membership-type-multi-select-column.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        CustomObjectSharedModule,
        ContactSharedModule
    ],
    declarations: [
        MembershipTypeSingleSelectEditControlComponent,
        MembershipTypeMultiSelectEditControlComponent,
        MembershipTypeMultiSelectColumnComponent,
        MemberLoyaltyAccrualTypeSingleSelectEditControlComponent,
        MemberLoyaltyAccrualTypeSingleSelectColumnComponent,
        MemberLoyaltyRedemptionTypeSingleSelectEditControlComponent,
        MemberLoyaltyRedemptionTypeSingleSelectColumnComponent,
        MembershipTypeReportSelectionControlComponent,
        MemberNoSingleSelectEditControlComponent,
        MemberReportSelectionControlComponent
    ],
    exports: [
        MembershipTypeSingleSelectEditControlComponent,
        MembershipTypeMultiSelectEditControlComponent,
        MembershipTypeMultiSelectColumnComponent,
        MemberLoyaltyAccrualTypeSingleSelectEditControlComponent,
        MemberLoyaltyAccrualTypeSingleSelectColumnComponent,
        MemberLoyaltyRedemptionTypeSingleSelectEditControlComponent,
        MemberLoyaltyRedemptionTypeSingleSelectColumnComponent,
        MembershipTypeReportSelectionControlComponent,
        MemberNoSingleSelectEditControlComponent,
        MemberReportSelectionControlComponent
    ]
})
export class CustomersSharedModule {
}
